const actions = {
  async listVariables(context, payload) {
    try {
      const { data: response } = await this.$api.call(
        "ruleEngine.getVariables",
        payload,
      );

      context.commit("setVariables", response);

      return response;
    } catch (error) {
      context.commit("setVariables", []);
      throw error;
    }
  },
};

export default actions;
